import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';

import { LOCALIZED_QUICK_ACTIONS } from '../../constants';
import { StyledDesktopDivider } from '../../VeloAIAssistant.style';
import { NotificationCard } from '../NotificationCard';
import { QuickActions } from '../QuickActions';

export const LOCALIZED_TEXT = {
  title: 'businessProfile.aiAssistant.note.title',
  message: 'businessProfile.aiAssistant.note.description',
};

function WelcomeView({ onClickQuickAction }) {
  return (
    <Stack spacing={2}>
      <NotificationCard title={LOCALIZED_TEXT.title} message={LOCALIZED_TEXT.message} />
      <StyledDesktopDivider />
      <QuickActions actions={LOCALIZED_QUICK_ACTIONS} onClick={onClickQuickAction} />
    </Stack>
  );
}

WelcomeView.propTypes = {
  onClickQuickAction: PropTypes.func,
};

export default WelcomeView;
